import { gql } from "apollo-boost"

export const getValidationFields = gql`
  query SubmissionValidation($id: ID!) {
    SubmissionValidation(id: $id) {      
      consultants {
        documents {
          name
        }
      }
      concepts {
          name
          type
        humanResource {
          identifiedConsultant
          isActive
          documents {
            type
            name
          }
        }
      }
      developmentObjectiveIndicators {
        title
      }
      generalObjectiveIndicators {
        title
      }
    }
  }
`
